/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-19 15:17:00
 * @FilePath: /unifyxp-v2-store-portal/src/components/GlobalTooltip/GlobalTooltip.tsx
 */
import React from 'react';
import { Tooltip } from 'antd';
import css from './GlobalTooltip.less';
interface IProps {
  children;
  title: string | number | JSX.Element;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  visible?: boolean;
  zIndex?;
}
export declare type TooltipPlacement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom';

const GlobalTooltip = (props: IProps) => {
  const { children, title, placement, overlayClassName, ...rest } = props;
  return (
    <Tooltip
      getPopupContainer={() => document.body}
      overlayClassName={overlayClassName}
      placement={placement}
      title={title}
      {...rest}>
      {children}
    </Tooltip>
  );
};
const NoWrapContainer = (props) => {
  const { children, className, style, onClick } = props;
  return (
    <div
      className={`${css.container} ${className || ''}`}
      onClick={onClick}
      style={style}>
      {children}
    </div>
  );
};
export { NoWrapContainer };
export default GlobalTooltip;
